import './App.css';
import { Routes, Route , Link, useNavigate } from 'react-router-dom';
import { Nav } from 'react-bootstrap'
import React, { useState } from 'react';
import Header from './Header'
import BpopupList from './Bpopup_list';
import Slider from './Slider';
import NewArrival from './NewArrival';
import Cardtemplate from './Cardtamplate';
import Brandfocus from './Brandfocus';
import Stylefinder from './Stylefinder';
import BestPick from './Bestpick';
import Detail from './Detail';
import all_data from "./all_data";
import Cart from './Cart.js'

function App() {
  const [showHeader, setShowHeader] = useState(false);

  let navigate = useNavigate();

  const handleMouseOver = () => {
    setShowHeader(true);
  };
  const handleMouseOut = () => {
    setShowHeader(false);
  };

  const [showBpopupList, setBpopupList] = useState(false);
  const popMouseOver = () => {
    setBpopupList(true);
  };
  const popMouseOut = () => {
    setBpopupList(false);
  };

  let [all] = useState(all_data);


  return (
    <>
      {/* -----------------    HEADER    ----------------- */}
      <header id="header">
        <div id="headerTop">
          <ul className='headerTop_menu'>
            <li><a href='#'>로그인</a></li>
            <li>|</li>
            <li><a href='#'>회원가입</a></li>
            <li>|</li>
            <li><a href='#'>고객센터</a></li>
          </ul>
        </div>

        <div id="headerBottom">
          <Link to='/'><img src='/img/logo.png' className='logo'></img></Link>
          <input type='text' className='heder_searchform' />
          <button className="serch"></button>
          <ul className='headerBottom_menu'>
            <li
              className="mypage"
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            ><a href='#'>마이페이지<img src='/img/icon_mypage.png' className='menuicon' /><img src='/img/icon_arrow_down.png' className='menu_arrow' />
              </a></li>

            <li><Link to="/cart"><a href='#'>쇼핑백<img src='/img/icon_basket.png' className='menuicon' /></a></Link></li>
            {showHeader && <Header />}
          </ul>

        </div>

        {/* -----네비----- */}
        <div id="nav">
          <div className='nav_brand' onMouseOver={popMouseOver}
            onMouseOut={popMouseOut}>
            <div className='brand'>
              <span>브랜드</span>
              <img src='/img/icon_arrow_down.png' />
            </div>
            {showBpopupList && <BpopupList />}
          </div>
          <ul className='navul'>
            <li><Link to="/detail/36">여성</Link></li>
            <li><Link to='/detail/8'>남성</Link></li>
            <li><Link to='/detail/21'>잡화/슈즈</Link></li>
            <li><Link to='/detail/98'>명품</Link></li>
            <li><Link to='/detail/24'>골프/스포츠</Link></li>
            <li><Link to='/detail/23'>비건뷰티</Link></li>
            <li><Link to='/detail/75'>리빙</Link></li>
            <li><Link to='/detail/79'>아울렛</Link></li>
            <li><Link to='/detail/34'>기획전/혜택</Link></li>
          </ul>
        </div>
      </header>




      <Routes>
        {/* -----------------    MAIN    ----------------- */}
        <Route path="/" element={<div>
          {/* ----슬라이더---- */}
          <Slider />


          {/* ----섹션1 New Arrival---- */}
          <h2 className='section1_title'>New Arrival</h2>
          <NewArrival />


          {/* ------섹션2------ */}
          <div id='section2'>
            <ul>
              <li><a href='#'><img src='img/section2/section2_1.png' /></a></li>
              <li><a href='#'><img src='img/section2/section2_2.png' /></a></li>
              <li><a href='#'><img src='img/section2/section2_3.png' /></a></li>
              <li><a href='#'><img src='img/section2/section2_4.png' /></a></li>
              <li><a href='#'><img src='img/section2/section2_5.png' /></a></li>
            </ul>
          </div>


          {/* ------섹션3------ */}
          <Cardtemplate />


          {/* ---섹션4 Brand Focus--- */}
          <h2 className='section4_title'>Brand Focus</h2>
          <Brandfocus />


          {/* --섹션5 LF 공식 수입 브랜드--- */}
          <h2 className='section5_title'>LF 공식 수입 브랜드</h2>
          <div className='lfbrand'>
            <a href='#'><img src='img/lfBrand/section6_1.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_2.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_3.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_4.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_5.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_6.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_7.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_8.jpg' /></a>
            <a href='#'><img src='img/lfBrand/section6_9.jpg' /></a>
          </div>



          {/* ---섹션6 Style Finder--- */}
          <h2 className='section5_title'>Style Finder</h2>
          <Stylefinder />



          {/* ----섹션7 Best Pick---- */}
          <h2 className='section6_title'>Best Pick</h2>
          <BestPick />
        </div>} />







    {/* -----------------    DETAIL    ----------------- */}
        <Route path="/detail/:id" element={<Detail all={all}/>} />
        <Route path="/cart" element={<Cart/>}/>
      </Routes>




      {/* -----------------    FOOTER    ----------------- */}
      <footer id="footer">
        <div className='footer_top'>
          <ul className='footer_category'>
            <li>회사소개</li>
            <li>이용약관</li>
            <li>개인정보처리방침</li>
            <li>읽기 쉬운 개인정보처리방침</li>
            <li>청소년보호정책</li>
            <li>고객센터</li>
            <li>제휴/입점문의</li>
            <li>패밀리 인증</li>
            <li>제휴임직원 인증</li>
          </ul>
          <ul className='information'>
            <li>
              <ul className='information_1'>
                <li>사업자 등록번호 : 211-87-87724</li>
                <li>통신판매업신고 : 제 2010-서울강남-00066호</li>
                <li><a>사업자 정보확인</a></li>
              </ul>
            </li>

            <li>
              <ul className='information_2'>
                <li>서울 강남구 언주로 870</li>
                <li>대표전화 : 1544-5114 (유료)</li>
                <li>팩스 : 031-360-0003</li>
                <li>이메일 : lfcs@lfcorp.com</li>
              </ul>
            </li>

            <li>
              <p>(주)LF 대표이사 오규식, 온라인사업총괄 도한준</p>
            </li>
          </ul>
          <div className='bank'>
            <img src="/img/ico_partner_2_v2.png" />
            <img src="/img/ico_parenter_3.png" />
            <img src="/img/ico_parenter_4.png" />
          </div>
          <div className='footerIcon'>
            <div className='footerIconBox'>
              <i class="fa-brands fa-instagram"></i>
            </div>
            <div className='footerIconBox'>
              <i class="fa-brands fa-facebook-f"></i>
            </div>
            <div className='footerIconBox'>
              <i class="fa-brands fa-youtube"></i>
            </div>
          </div>
        </div>

        <div className='footer_bottom'>
          <div className='footer_bottom_inner'>
            <p>해외배송 상품, 구매대행 상품, 항공권/호텔예약 및 여행편의 서비스의 경우, (주)엘에프는 통신판매중개자이며, 통신판매의 당사자가 아닙니다. (주)엘에프는 해당 해외배송 상품 또는 구매대행 상품, 항공권/호텔예약 및 여행편의 서비스의 거래 정보 및 거래 등에 대하여 책임을 지지 않습니다.</p>
            <span>COPYRIGHT 2004 LF ALL RIGHTS RESERVED</span>
          </div>
        </div>
      </footer>

      <div className='TOPbutton' onClick={() => window.scrollTo(0, 0)}><img src="/img/TOPbutton.png" /></div>
    </>
  );
}

export default App;
